import api from './api'

const requestService = {
  // Get all requests
  getRequests: (params) => api.get('/mrd/requests', { params }),

  // Get request by ID
  getRequestById: (id) => api.get(`/mrd/requests/${id}`),

  // Create new request
  createRequest: (data) => api.post('/mrd/requests', data),

  // Update request
  updateRequest: (id, data) => api.put(`/mrd/requests/${id}`, data),

  // Delete request
  deleteRequest: (id) => api.delete(`/mrd/requests/${id}`),

  // Assign request
  assignRequest: (id, data) => api.post(`/mrd/requests/${id}/assign`, data),

  // Fulfill request
  fulfillRequest: (id, data) => api.post(`/mrd/requests/${id}/fulfill`, data),

  // Return request files
  returnRequest: (id, data) => api.post(`/mrd/requests/${id}/return`, data),

  // Receive request
  receiveRequest: (id, data) => api.post(`/mrd/requests/${id}/receive`, data),

  // Reject request
  rejectRequest: (id, data) => api.post(`/mrd/requests/${id}/reject`, data),

  // Approve request (alias for assign or fulfill based on status)
  approveRequest: (id, data) => api.post(`/mrd/requests/${id}/assign`, data),

  // Close request
  closeRequest: (id, data) => api.post(`/mrd/requests/${id}/close`, data),

  // Reopen request
  reopenRequest: (id, data) => api.post(`/mrd/requests/${id}/reopen`, data),

  // Get pending requests
  getPendingRequests: (params) => api.get('/mrd/requests/status/pending', { params }),

  // Get overdue requests
  getOverdueRequests: (params) => api.get('/mrd/requests/status/overdue', { params }),

  // Get request statistics
  getRequestStats: (params) => api.get('/mrd/requests/stats/summary', { params }),

  // Get dashboard data
  getDashboardData: (params) => api.get('/mrd/requests/dashboard/data', { params }),

  // Get audit trail
  getAuditTrail: (requestId) => api.get(`/mrd/requests/audit/${requestId}`),

  // Generate invoice
  generateInvoice: (id) => api.post(`/mrd/requests/${id}/generate-invoice`),

  // Update payment status
  updatePaymentStatus: (id, data) => api.post(`/mrd/requests/${id}/update-payment`, data),

  // Send reminder
  sendReminder: (id, data) => api.post(`/mrd/requests/${id}/send-reminder`, data)
}

export default requestService